import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import cogoToast from "cogo-toast-react-17-fix";
import TopTitleBar from "./TopTitleBar";
import Loader from "../../../components/Loader";
import API from '../../../ApiConfig'
import { BASE_URL, GET_DOCUMENT_FORM_FIELDS, INSERT_ISSUER_DOCUMENT, UPLOAD_BULK_CSV, USER_TOKEN } from "../../../Utils/constant";
import { json2csv, csv2json } from 'json-2-csv';
import useRefreshToken from "../../../Hooks/usegenerateToken";
import { Icon } from 'react-icons-kit';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';
import SlideUpWrapper from "../../../components/Transitions/SlideUpWrapper";
import ShimmerLoader from "../../../components/ShimmerLoader";
import { Delay } from "../../../Utils/helper";
import Breadcrumb from "../../../components/Verifier/breadcrumb/BreadCrumb";
import IssuerNavigator from "../../../components/DashBoard/IssuerNavigator";
import { useSelector } from "react-redux";

const BulkUpload = ({ doc, handleStep }) => {
  let access_token = useRefreshToken(BASE_URL + USER_TOKEN)

  const [selectedFile, setSelectedFile] = useState(null);
  const [droppedFileName, setDroppedFileName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileData, setFileData] = useState([])
  const [templateData, setTemplateData] = useState([])
  const [fieldData, setFieldData] = useState([])
  const [dataInserted, setDataInserted] = useState(false)
  const [successCount, setSucessCount] = useState(0)

  const [errorCount, setErrorCount] = useState(0);
  const [Disable, IsDisable] = useState(false)
  const [uploadedData, setUploadedData] = useState({ success: [], error: [], isUploaded: false })
  const userDetails= useSelector(state=>state.config)
  const fileInputRef = useRef(null);
  const navigate=useNavigate()
  useEffect(() => {
    if (doc.id)
      getFormFields()
  }, [])

  async function getFormFields() {
    setLoading(true)
    await Delay()
    API.get(GET_DOCUMENT_FORM_FIELDS + doc.id)
      .then(res => {
        if (res.data.status === 200) {
          let listData = res.data?.data
          let data = []
          let field = {}
          listData.map(item => {
            field[item.field_name] = ''
          })
          
          data.push(field)
          setTemplateData(listData)
          setFieldData(listData)
          setLoading(false)
        }
      })
      .catch(err => {
        setLoading(false)
      })
  }
  const downLoadTemplate = async (e, data, name) => {
    e.preventDefault()
    const escapeCsvValue = (value) => {
      if (value == null) return "";

      return `"${String(value).replace(/"/g, '""')}"`;
    }
    const fieldNames = data.map(item => escapeCsvValue(item.field_name) || "");
    const placeholders = data.map(item => escapeCsvValue(item.placeholder) || "")
    const csv = `${fieldNames.join(",")}\n${placeholders.join(",")}`;

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  const downloadErrorCSV=async(e, errorData)=>{
    e.preventDefault()


    try {
      const dataArray = Array.isArray(errorData) ? errorData : [errorData];

      const csvData = await json2csv(dataArray, {
        expandArrayObjects: false,
        useLocaleFormat: false,
        prependHeader: true,
        unwindArrays: false,
        delimiter: { field: ',', wrap: '"' },
      })
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = "error" + '.csv';
    document.body.appendChild(a);
    
    a.click();
    document.body.removeChild(a)
    window.URL.revokeObjectURL(url)


    }

    catch (error) {
      console.error("CSV generation failed:", error);
    }
    
    

  }
  const handleBoxClick = () => fileInputRef.current.click()

  const handleFileChange = async (e) => {
    e.preventDefault();
    setDataInserted(false)
    const file = e.target.files[0];

    if (file) {
      setSelectedFile(file);
      setDroppedFileName(file.name);
    }
  };


  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDataInserted(false);
    const droppedFile = event.dataTransfer.files[0];

    if (droppedFile) {
      setSelectedFile(droppedFile);
      setDroppedFileName(droppedFile.name);
    }
  };
  function handleUploadComplete() {
    setLoading(false)
    if (uploadedData.error.length > 0) {
      cogoToast.error('Some data points are not in valid format please have have a look on error csv')
    }
    if (uploadedData.success.length > 0) {
      setSucessCount(uploadedData.success.length)
      setDataInserted(true)
    }
    if (uploadedData.success.length === 0) {
      setSucessCount(0)
      setDataInserted(true)
    }
  }
  const handleUpload = (e) => {
    e.preventDefault();
    if (selectedFile) {
      saveFormData(selectedFile)
    }
    else
      cogoToast.error("Please select a file with data")

  };
  function saveFormData(file) {
    let params = new FormData();
    params.append("file", file)
    params.append("issuer_id", doc.issuer_id)
    params.append("document_id", doc.id)

    setLoading(true)

    API.post(UPLOAD_BULK_CSV, params)
      .then(res => {
        if (res.status === 200) {
          setLoading(false)
          let { error_data, success_count, error_count, } = res.data.data;
          setFileData(error_data);
          setSucessCount(success_count);
          setErrorCount(error_count);
          setDataInserted(true)
          if (success_count === 0) {
            cogoToast.error("All data points are Incorrect please check the file");
          }
          else {
            cogoToast.success(`${success_count} uploaded`);
          }

        }
      })
      .catch(err => {
        setLoading(false)
        cogoToast.error(err.response.data.message)
      })
  }

  useEffect(() => {
    if (uploadedData.isUploaded) {
      handleUploadComplete()
    }
  }, [uploadedData])
  return (
    <div style={{width:"100%"}}>
      <Loader isOpen={loading} />
      <Breadcrumb pos={3} title="Issue Document" category="issuer" />
      <SlideUpWrapper>
        <IssuerNavigator
          title="Add Recipient details"
          handlestep={handleStep}
          step={3}
          actions={() => null}
        />
        {/* <TopTitleBar isChild>
          <h2 className="topTitleBarText">
            <Link className="text-decoration-none" to="/dashboard/credentials">
              Credentials
            </Link>
            <span className="text-decoration-none" onClick={e => handleStep(1)}> <Icon icon={arrow_right} /> Issue Crdentials</span>
            <span className="secondaryButton"> <Icon icon={arrow_right} /> Bulk Upload</span>
          </h2>
        </TopTitleBar > */}
        {!dataInserted ? <div className="bulkupload-container">
          <div className="form-schema">
            <div className="schema-title">{doc.doc_name} Schema</div>
            <div className="schema-header"><div className="schema-item" >Field Name</div><div >Field Format</div></div>
            {loading ? <>
              <div className="schema-data"> <div className="schema-item" ><ShimmerLoader width="6rem" /></div><div><ShimmerLoader width="6rem" /></div></div>
              <div className="schema-data"> <div className="schema-item" ><ShimmerLoader width="6rem" /></div><div><ShimmerLoader width="6rem" /></div></div>
            </> :
              <>
                {fieldData.map(item => {
                  return <div className="schema-data"> <div className="schema-item" >{item.field_name}{item.is_required ? <span className="astric">*</span> : null}</div><div>{item.placeholder}</div></div>
                })}
              </>}

          </div>
          <div className="bulkupload-wrapper">
            <div className="bulkupload-header">
              <span>Doc Name</span>
              <div className="bulkupload-docname">
                {doc?.doc_name}
              </div>
            </div>
            <div className="drag-container">
              <div className="dragH1">
                {loading ? <ShimmerLoader height="12.5rem" /> :
                  <div
                    className={`${"fileUploadBox"} ${selectedFile ? "fileSelected" : ""}`}
                    onClick={handleBoxClick}
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <input
                      type="file"
                      ref={fileInputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      accept=".csv"
                    />
                    {droppedFileName || selectedFile ? (
                      <p style={{ fontWeight: "600" }}>
                        Selected File: {droppedFileName || selectedFile.name}
                      </p>
                    ) : (
                      <div className="dragContent">
                        <img src="/uploadoutline.svg" alt="upload icon" />
                        <p style={{ fontWeight: "700" }}>
                          Upload a CSV with recipients' data from your computer
                        </p>
                        <p
                          style={{ color: "Gray" }}
                        >{`CSV (Max.5mb)`}</p>
                      </div>
                    )}
                  </div>}
                <div className="buttonContainer">
                  {loading ? <>
                    <ShimmerLoader mt=".8rem" width="15rem" height="2.5rem" />
                    <ShimmerLoader mt=".8rem" ml='1rem' width="15rem" height="2.5rem" />
                  </> : <>
                    <div className="btn3" onClick={(e) => downLoadTemplate(e, templateData, doc.doc_name)}>
                      <div>
                        <img
                          className="uploadOutlineIcon"
                          alt=""
                          src="/downloadUpload.svg"
                          style={{ width: "15px", paddingRight: "7px" }}
                        />
                      </div>
                      <div style={{ fontWeight: "500", padding: "1px" }}>
                        Download Bulk Template
                      </div>
                    </div>
                    <button className={`btn4 ${!selectedFile?"btn-secondary":""}`} onClick={handleUpload} disabled={!selectedFile} style={!selectedFile?{color:"gray"}:{color:"white"}}>
                      <div>
                        <img
                          className="uploadOutlineIcon"
                          alt=""
                          src="/uploadBulk.svg"
                          style={{ width: "15px", paddingRight: "7px" }}
                        />
                      </div>
                      <div style={{fontWeight:"500", padding:"1px"}}
                      >
                        Upload Bulk List
                      </div>
                    </button>
                  </>

                  }
                </div>
              </div>
            </div>
          </div>
        </div> : <div className="bulkupload-container1">
          <div className="w-50 m-auto">
            <div className="bulk-status" >
              <div className="correct-bulk">
                <div>
                  <img src="/checkcircle.svg" style={{ width: "30px" }} />
                </div>
                <div>
                  <span style={{ color: "darkgreen" }}>{droppedFileName || selectedFile.name}</span>
                  <p style={{ color: "green" }}>{successCount} uploaded</p>
                </div>
              </div>
            </div>
            <div className="status-btn">
              <button className="btn5 ml-0" onClick={e =>  downloadErrorCSV(e, fileData, 'error')} disabled={fileData == null}>
                <img
                  src="/downloadUpload.svg"
                />
                <div style={{ fontWeight: "700" }}>
                  Download Error CSV({errorCount})
                </div>
              </button>
              <div className="btn5 mr-0" onClick={e => setDataInserted(false)}>
                <img
                  src="/uploadoutline.svg"
                />
                <div >
                  Re-Upload Bulk List
                </div>
              </div>
            </div>

            {successCount > 0 ? <button className="btn btn-primary" onClick={e => {userDetails.bulk_upload_document_state_enabled?navigate("/dashboard/credentials"):handleStep(4)}} >
              Continue
            </button> : null}
          </div>


        </div>}
      </SlideUpWrapper>
    </div>
  );
};

export default BulkUpload;
